import {
    ON_INTENT_TYPE_CHANGE,
    FETCH_ERROR,
    FETCH_START,
    FETCH_SUCCESS,
    INTENT_REQUEST_DATA,
    INTENT_POST_START,
    INTENT_POST_RESPONSE,
    INTENT_INITIAL_FORM_DATA,
    INTENT_DENOMINATIONS_FORM_DATA,
    INTENT_OFFICERS_FORM_DATA,
    ON_PATCH_RESPONSE,
    ON_PUT_RESPONSE,
    LOAD_INTENTS,
    LOAD_INTENT_SINGLE_START,
    LOAD_INTENT_SINGLE_DONE,
    SINGLE_INTENT_DATA,
    INTENT_FILE_FETCH_START,
    INTENT_FILE_FETCH_DONE,
    INTENT_FILE_FETCH_ERROR,
    INTENT_FILE
} from './../constants/ActionTypes';


import intentAPI from '../util/IntentsApi';
import adminApi from 'util/AdminApi';

export const postIntentRequest = (postData, intentType) => {
    let token = sessionStorage.getItem('token');

    const opts = {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    }

    return (dispatch) => {
        dispatch({ type: FETCH_START });
        dispatch({ type: INTENT_POST_START });
        let endPoint = '/intentRequest/'.concat(intentType);
        intentAPI.post(endPoint, postData, opts).then(({ data }) => {
            if (data.success > 0) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: INTENT_POST_RESPONSE, payload: data });
            } else {
                dispatch({ type: FETCH_ERROR, payload: "Error occured." });
            }
        }).catch((error) => {
            dispatch({ type: FETCH_ERROR, payload: error.message });
        });
    }

}

export const putIntentRequest = (postData, intentType, requestId) => {

    let token = sessionStorage.getItem('token');

    const opts = {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    }

    return async (dispatch) => {
        dispatch({ type: FETCH_START });
        let endPoint = '/intent/'.concat(intentType, '/', requestId);
        await intentAPI.put(endPoint, postData, opts
        ).then(({ data }) => {
            if (data.success > 0) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: ON_PUT_RESPONSE, payload: data });
            } else {
                dispatch({ type: FETCH_ERROR, payload: "Error occured." });
            }
        }).catch((error) => {
            dispatch({ type: FETCH_ERROR, payload: error.message });
        });
    }

}

export const postIntentInitialFormData = (info) => {
    return (dispatch) => {
        dispatch({ type: INTENT_INITIAL_FORM_DATA, payload: info });
    }
}

export const postIntentDenominationsFormData = (denominations) => {
    return (dispatch) => {
        dispatch({ type: INTENT_DENOMINATIONS_FORM_DATA, payload: denominations });
    }
}

export const postIntentOfficersFormData = (officers) => {
    return (dispatch) => {
        dispatch({ type: INTENT_OFFICERS_FORM_DATA, payload: officers });
    }
}

export const getIntentRequests = (intentType = null, params = null) => {
    const endPoint = 'intentRequest/'.concat((intentType !== null) ? intentType : 0);//0 for all requests
    let token = sessionStorage.getItem('token');

    const opts = {
        params: params,
        headers: {
            Authorization: `Bearer ${token}`,
        }
    }

    return async (dispatch) => {
        dispatch({ type: FETCH_START });
        dispatch({ type: LOAD_INTENTS });
        await intentAPI.get(endPoint, opts
        ).then(({ data }) => {

            dispatch({ type: FETCH_SUCCESS });
            // format data and store them for use..
            dispatch({ type: INTENT_REQUEST_DATA, payload: data });
        }).catch((error) => {

            dispatch({ type: FETCH_ERROR, payload: error.message });
        });
    }
}

export const getIntentRequestSingle = (intentType, intentId, params = null) => {
    const endPoint = 'intent/'.concat(intentType, '/', intentId);
    let token = sessionStorage.getItem('token');

    const opts = {
        params: params,
        headers: {
            Authorization: `Bearer ${token}`,
        }
    }

    return async (dispatch) => {
        dispatch({ type: LOAD_INTENT_SINGLE_START });
        await intentAPI.get(endPoint, opts
        ).then(({ data }) => {

            dispatch({ type: LOAD_INTENT_SINGLE_DONE });

            dispatch({ type: SINGLE_INTENT_DATA, payload: data });
        }).catch((error) => {

            dispatch({ type: FETCH_ERROR, payload: error.message });
        });
    }
}

export const resetIntentDataSingle = () => {
    return async (dispatch) => {
        dispatch({ type: SINGLE_INTENT_DATA, payload: null });
    }
}

export const patchIntentRequestData = (intentId, payload, comments = "") => {
    let token = sessionStorage.getItem('token');

    const opts = {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    }

    let _payload = [
        {
            "op": "replace",
            "path": "",
            "value": payload,
            "from": "",
            "comments": comments
        }
    ];

    return async (dispatch) => {
        dispatch({ type: FETCH_START });
        let endPoint = '/intent/'.concat(intentId);
        await intentAPI.patch(endPoint, _payload, opts
        ).then(({ data }) => {
            if (data) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: ON_PATCH_RESPONSE, payload: data });
            } else {
                dispatch({ type: FETCH_ERROR, payload: data });
            }
        }).catch((error) => {
            dispatch({ type: FETCH_ERROR, payload: error.message });
        });
    }
}

export const getIntentFiles = (intentId, params) => {
    const endPoint = 'intentFile/' + intentId;
    let token = sessionStorage.getItem('token');
    const opts = {
        params: params,
        headers: {
            Authorization: `Bearer ${token}`,
        }
    }
    return async (dispatch) => {
        dispatch({ type: INTENT_FILE_FETCH_START });
        await intentAPI.get(endPoint, opts
        ).then(({ data }) => {
            dispatch({ type: INTENT_FILE_FETCH_DONE });
            dispatch({ type: INTENT_FILE, payload: data });
        }).catch((error) => {
            dispatch({ type: INTENT_FILE_FETCH_ERROR, payload: error.message });
        });
    }
}

export const pushTrxToCBS = (id, payload, reason) => {

    let token = sessionStorage.getItem('token');

    const opts = {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    }

    let endPoint = '/depositwithdrawconfirmation';

    return async (dispatch) => {
        dispatch({ type: FETCH_START });
        await adminApi.post(endPoint, payload, opts
        ).then(({ data, status }) => {
            dispatch({ type: FETCH_SUCCESS });
            if (status === 200) {
                dispatch({ type: ON_PATCH_RESPONSE, payload: { status: 200, message: data.message } });
            } else {
                dispatch({ type: FETCH_ERROR, payload: "Error occured,contact admistrator." });
            }
        }).catch((error) => {
            dispatch({ type: FETCH_ERROR, payload: error.message });
        });
    }
}
